import { render, staticRenderFns } from "./difficulty-game.vue?vue&type=template&id=bb321a1e&scoped=true&"
import script from "./difficulty-game.vue?vue&type=script&lang=js&"
export * from "./difficulty-game.vue?vue&type=script&lang=js&"
import style0 from "./difficulty-game.vue?vue&type=style&index=0&id=bb321a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb321a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb321a1e')) {
      api.createRecord('bb321a1e', component.options)
    } else {
      api.reload('bb321a1e', component.options)
    }
    module.hot.accept("./difficulty-game.vue?vue&type=template&id=bb321a1e&scoped=true&", function () {
      api.rerender('bb321a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/difficulty-game.vue"
export default component.exports